var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "137",
      "height": "87"
    }
  }, _vm.$listeners), [_c('path', {
    attrs: {
      "fill": "#FFF",
      "stroke": "#FFF",
      "stroke-linecap": "square",
      "stroke-width": ".7",
      "d": "M2.989 4.527a.5.5 0 0 1 .352-.287l.431-.106c.173-.114 11.02-2.18 11.02-2.18.243-.06.476.052.528.254.053.2-.11.426-.333.495L7.442 4.545c6.963 1.375 25.118 5.469 46.193 14.26 24.811 10.351 58.874 29.52 80.246 62.057.197.301.054.71-.32.915a1 1 0 0 1-.16.068c-.337.11-.705.016-.875-.243C111.328 49.329 77.518 30.3 52.887 20.02 31.548 11.113 13.243 7.058 6.622 5.767l5.066 5.062c.136.16.091.399-.103.543a.6.6 0 0 1-.159.081.48.48 0 0 1-.47-.08L3.072 4.905a.33.33 0 0 1-.082-.38"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }